<template>
    <v-card>
       <v-card-text>
          <v-row>
            <v-col cols="12">
              <v-text-field
                label="Title"
                v-model.trim="tile.title"
                type="text"
                placeholder="Title"
                id="title"
              ></v-text-field>
               <v-text-field
                label="Hint"
                v-model.trim="tile.hint"
                type="text"
                placeholder="Hint"
                id="hint"
              ></v-text-field>
            </v-col>
          </v-row>
      </v-card-text>
    </v-card>
</template>

<script>
// @ is an alias to /src
export default {
  name: "AdminKeywordsAdd",
  data() {
    return {
      isValid: true
    };
  },
  props: {
    tile: Object
  },
  methods: {
    
  }
};
</script>
